import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { hot } from 'react-hot-loader/root'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import CreateReport from 'views/Create/CreateReport'
import { fetchPackages } from 'actions/packages'
import { getWorkflowSteps } from 'utils/business/workflow'
import ProgressHeader from 'views/Create/ProgressHeader'
import Spinner from 'components/Spinner'
import JobTitleBanner from 'components/JobTitleBanner'

class CreateJob extends Component {
  static propTypes = {
    app: PropTypes.shape({
      user: PropTypes.shape({
        _isFetched: PropTypes.bool,
        isExternal: PropTypes.bool,
      }),
    }).isRequired,
    clonedJobDetails: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        isCloned: PropTypes.string,
      }),
    }),
  }

    static defaultProps = {
      match: null,
    }

    componentDidMount() {
      const { dispatch } = this.props
      dispatch(fetchPackages())
    }

    render() {
      const {
        app: { user: { _isFetched, isExternal } },
        clonedJobDetails,
      } = this.props
      const steps = getWorkflowSteps()

      return (
        <div>
          {clonedJobDetails._isCloning && (
            <JobTitleBanner
              isCloning
              isExternal={isExternal}
              job={clonedJobDetails}
            />
          )}
          <ProgressHeader
            currentStep={1}
            maximumStepAccess={1}
            steps={steps}
          >

            {_isFetched
              ? (
                <CreateReport
                  isCloned={clonedJobDetails._isCloning}
                  {...this.props}
                />
              )
              : (
                <div style={{ margin: 'auto', width: '70px', paddingTop: '200px' }}>
                  <Spinner size="large" />
                </div>
              )
          }

          </ProgressHeader>

        </div>
      )
    }
}

const mapStateToProps = state => ({
  job: state.job,
  packages: state.packages,
  engagementCodes: state.engagementCodes,
  forms: state.forms,
  tests: state.tests,
  app: state.app,
  clonedJobDetails: state.clonedJobDetails,
})

export default hot(withRouter(connect(mapStateToProps)(CreateJob)))
